// extracted by mini-css-extract-plugin
module.exports = {"columnContainer":"globalfooter_columnContainer__HwMnc","copyrightContainer":"globalfooter_copyrightContainer__WmyHU","mobileAccordion":"globalfooter_mobileAccordion__s1nC_"};